export default class TaxStatementsAbstractServices {
  static getTaxStatementSummary(memberNumber, numberOfYears, currentYear, options) {
    logger.error(`TaxStatements:: getTaxStatementSummary(${memberNumber}, ${numberOfYears}, ${currentYear}) not implemented`);
  }

  static getTaxStatementDocument(memberNumber, accessingPersonCode, documentId) {
    logger.error(`TaxStatements:: getTaxStatementDocument( ${memberNumber},${accessingPersonCode}, ${documentId}) not implemented`);
  }

  static getReferenceData() {
    logger.error(`TaxStatements:: getReferenceData not implemented`);
  }

  static generateTaxStatement(memberNumber, financialYear) {
    logger.error(`TaxStatements:: generateTaxStatement(${memberNumber}, ${financialYear}) not implemented`);
  }
}
